import AppCtrl from './controllers/root';

export default function ($stateProvider, $locationProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/');

    let root = {
        name: 'root',
        url: '/',
        controllerAs: 'root',
        template: require('./views/root.html'),
        controller: AppCtrl
    };

    $stateProvider.state(root);

    // $locationProvider.html5Mode(true);
}


// WEBPACK FOOTER //
// ./src/app/config.js